import { render, staticRenderFns } from "./MentionList.vue?vue&type=template&id=1cbfd934&scoped=true"
import script from "./MentionList.vue?vue&type=script&lang=js"
export * from "./MentionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbfd934",
  null
  
)

export default component.exports